import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Upload from "@/pages/Upload";
import Explanation from "@/pages/Explanation";
import ActionCard from "@/pages/ActionCard";
import Shared from "@/pages/Shared";
import CareBinder from "@/pages/CareBinder";
import "@/App.css";

export default function App() {
  return (
    <div className="min-h-screen bg-bone cn-grain text-slate-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/my-letters" element={<CareBinder />} />
          <Route path="/letter/:id" element={<Explanation />} />
          <Route path="/letter/:id/action" element={<ActionCard />} />
          <Route path="/share/:shareToken" element={<Shared />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        theme="light"
        toastOptions={{
          style: {
            fontSize: "17px",
            fontFamily: "'IBM Plex Sans', sans-serif",
            borderRadius: "14px",
            border: "2px solid #CBD5E1",
          },
        }}
      />
    </div>
  );
}
